import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColour",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "inherit",
      d: "M5.594 16.516a.98.98 0 0 1-.705-.302 1.05 1.05 0 0 1-.291-.73c0-.274.105-.537.291-.73a.98.98 0 0 1 .705-.302c1.342 0 1.41-1.216 1.41-1.461V7.51c0-.274.105-.537.291-.73A.98.98 0 0 1 8 6.477c.264 0 .518.11.704.303.187.193.292.456.292.73v5.481c0 1.417-.906 3.525-3.402 3.525",
      class: "fill-primary"
    }, null, -1),
    _createElementVNode("path", {
      fill: "inherit",
      d: "M16 8.258H0l.03-1.06C.147 3.16 3.649 0 8 0s7.853 3.161 7.97 7.197zM2.177 6.194h11.646c-.62-2.354-3.018-4.13-5.823-4.13-2.804 0-5.203 1.776-5.823 4.13",
      class: "fill-secondary"
    }, null, -1)
  ])))
}
export default { render: render }